// ! PRODUCT MEDIA GALLERY

if (!customElements.get('poncho-product-info')) {
  
  customElements.define(
    
    'poncho-product-info',
    
    class PonchoProductInfo extends HTMLElement {
      
      constructor() {
        super();
        
        const _self = this;
        
        // option groups that might have options with no variant
        const troubleOptionGroups = ['fit','this-size'];
        
        // listen for product info change
        document.addEventListener('productinfo:changed', () => {
          
          for (let i=0; i < troubleOptionGroups.length; i++) {
            
            let breakLoop = false;
            const group = _self.querySelector(`.product-form__input--${troubleOptionGroups[i]}`);
            
            if (group && group.querySelectorAll('input[type=radio]').length > 1) {
              
              group.querySelectorAll('input[type=radio]').forEach((input, index)=>{
                
                // if the checked option is disabled
                if ( input.checked && input.classList.contains('unavailable') ) {
                  
                  // find the first not disabled option and click it
                  const clickable = group.querySelector('input[type=radio]:not(.disabled)');
                  clickable?.click();
                  
                  // prepare to break the outer loop
                  breakLoop = true;
                }
                
              });
            }
            
            if (breakLoop) break;
          }
          
        });
      }
      
      selectAvailableOption(selector) {
        
        const group = this.querySelector('.product-form__input--this-size');
        if (group) {
          group.querySelectorAll('input[type=radio]').forEach((input, index)=>{
            
            // if the checked option is disabled
            if ( input.checked && input.classList.contains('disabled') ) {
              
              // find the first not disabled option and click it
              const clickable = group.querySelector('input[type=radio]:not(.disabled)');
              clickable?.click();
            }
            
          });
        }
      }
    }
  );
}


// ! PRODUCT INFO

if (!customElements.get('product-info')) {
  
  customElements.define(
    
    'product-info',
    
    class ProductInfo extends HTMLElement {
      abortController = undefined;
      onVariantChangeUnsubscriber = undefined;
      pendingRequestUrl = null;
      preProcessHtmlCallbacks = [];
      postProcessHtmlCallbacks = [];
      cartUpdateUnsubscriber = undefined;

      constructor() {
        super();
      }

      get variantSelectors() {
        return this.querySelector('variant-selects');
      }

      get productId() {
        return this.getAttribute('data-product-id');
      }

      get sectionId() {
        return this.dataset.originalSection || this.dataset.section;
      }

      get pickupAvailability() {
        return this.querySelector(`pickup-availability`);
      }

      get productForm() {
        return this.querySelector('form[is="product-form"]');
      }

      get quantityInput() {
        return this.querySelector('quantity-input input');
      }

      connectedCallback() {
        this.initializeProductSwapUtility();

        this.onVariantChangeUnsubscriber = PCOtheme.pubsub.subscribe(
          PCOtheme.pubsub.PUB_SUB_EVENTS.optionValueSelectionChange,
          this.handleOptionValueChange.bind(this)
        );

        this.initQuantityHandlers();

        this.currentVariant = this.getSelectedVariant(this);
        if (this.currentVariant) {
          this.updateMedia(this.currentVariant);
        }
      }

      disconnectedCallback() {
        this.onVariantChangeUnsubscriber();
        this.cartUpdateUnsubscriber?.();
      }

      initializeProductSwapUtility() {
        this.postProcessHtmlCallbacks.push((newNode) => {
          window?.Shopify?.PaymentButton?.init();
          window?.ProductModel?.loadShopifyXR();
        });
      }

      handleOptionValueChange({ data: { event, target, selectedOptionValues } }) {
        if (!this.contains(event.target)) return;
        const productUrl = target.dataset.productUrl || this.pendingRequestUrl || this.dataset.url;
        const shouldSwapProduct = this.dataset.url !== productUrl;
        const shouldFetchFullPage = this.dataset.updateUrl === 'true' && shouldSwapProduct;
        const viewMode = this.dataset.viewMode || 'main-product';
        
        this.renderProductInfo({
          requestUrl: this.buildRequestUrlWithParams(productUrl, selectedOptionValues, shouldFetchFullPage),
          targetId: target.id,
          callback: shouldSwapProduct
            ? this.handleSwapProduct(productUrl, shouldFetchFullPage, viewMode)
            : this.handleUpdateProductInfo(productUrl, viewMode),
        });
        
        document.dispatchEvent(
          new CustomEvent('optionvalue:changed')
        );
      }

      handleSwapProduct(productUrl, updateFullPage, viewMode) {
        return (html) => {
          const quickView = html.querySelector('#MainProduct-quick-view__content');
          if (quickView && viewMode === 'quick-view') {
            html = quickView.content.cloneNode(true);
          }
          const selector = updateFullPage ? "product-info[id^='MainProduct']" : 'product-info';
          const variant = this.getSelectedVariant(html.querySelector(selector));

          this.updateURL(productUrl, variant?.id);

          if (updateFullPage) {
            document.querySelector('head title').innerHTML = html.querySelector('head title').innerHTML;
            HTMLUpdateUtility.viewTransition(
              document.querySelector('main'),
              html.querySelector('main'),
              this.preProcessHtmlCallbacks,
              this.postProcessHtmlCallbacks
            );
            HTMLUpdateUtility.viewTransition(
              document.getElementById('shopify-section-sticky-atc-bar'),
              html.getElementById('shopify-section-sticky-atc-bar'),
              this.preProcessHtmlCallbacks,
              this.postProcessHtmlCallbacks
            );
          } else {
            HTMLUpdateUtility.viewTransition(
              this,
              html.querySelector('product-info'),
              this.preProcessHtmlCallbacks,
              this.postProcessHtmlCallbacks
            );
          }
          
          this.currentVariant = variant;
        };
      }

      handleUpdateProductInfo(productUrl, viewMode) {
        return (html) => {
          const quickView = html.querySelector('#MainProduct-quick-view__content');
          if (quickView && viewMode === 'quick-view') {
            html = quickView.content.cloneNode(true);
          }
          const variant = this.getSelectedVariant(html);

          this.pickupAvailability?.update(variant);
          this.updateOptionValues(html);
          this.updateURL(productUrl, variant?.id);
          this.updateShareUrl(variant?.id);
          this.updateVariantInputs(variant?.id);

          if (!variant) {
            this.setUnavailable();
            return;
          }

          this.updateMedia(variant);

          const updateSourceFromDestination = (id, shouldHide = (source) => false) => {
            const source = html.getElementById(`${id}-${this.sectionId}`);
            const destination = this.querySelector(`#${id}-${this.dataset.section}`);

            if (source && destination) {
              destination.innerHTML = source.innerHTML;
              destination.classList.toggle('hidden', shouldHide(source));
            }
          };
          
          updateSourceFromDestination('price');
          updateSourceFromDestination('PriceDesktop');
          updateSourceFromDestination('PriceMobile');
          updateSourceFromDestination('Sku', ({ classList }) => classList.contains('hidden'));
          updateSourceFromDestination('Inventory', ({ innerText }) => innerText === '');
          updateSourceFromDestination('Badges', ({ classList }) => classList.contains('hidden'));
          updateSourceFromDestination('PricePerItem', ({ classList }) => classList.contains('hidden'));
          updateSourceFromDestination('Volume');
          updateSourceFromDestination('Availability', ({ innerText }) => innerText === '');
          updateSourceFromDestination('GooddayBuyerPromise', ({ innerText }) => innerText === '');

          this.updateQuantityRules(this.sectionId, this.productId, html);
          this.querySelector(`#QuantityRules-${this.dataset.section}`)?.classList.remove('hidden');
          this.querySelector(`#VolumeNote-${this.dataset.section}`)?.classList.remove('hidden');

          HTMLUpdateUtility.viewTransition(
            document.querySelector(`#SizeChart-${this.sectionId}`),
            html.querySelector(`#SizeChart-${this.sectionId}`),
            this.preProcessHtmlCallbacks,
            this.postProcessHtmlCallbacks
          );

          const addButtonUpdated = html.getElementById(`ProductSubmitButton-${this.sectionId}`);
          this.toggleAddButton(
            addButtonUpdated ? addButtonUpdated.hasAttribute('disabled') : true,
            PCOtheme.variantStrings.soldOut
          );

          PCOtheme.pubsub.publish(PCOtheme.pubsub.PUB_SUB_EVENTS.variantChange, {
            data: {
              sectionId: this.sectionId,
              html,
              variant,
            },
          });
          
          document.dispatchEvent(
            new CustomEvent('variant:changed', {
              detail: {
                variant: variant,
              },
            })
          );
        };
      }

      buildRequestUrlWithParams(url, optionValues, shouldFetchFullPage = false) {
        const params = [];

        !shouldFetchFullPage && params.push(`section_id=${this.sectionId}`);

        if (optionValues.length) {
          params.push(`option_values=${optionValues.join(',')}`);
        }

        return `${url}?${params.join('&')}`;
      }

      getSelectedVariant(productInfoNode) {
        const selectedVariant = productInfoNode.querySelector('variant-selects [data-selected-variant]')?.innerHTML;
        return !!selectedVariant ? JSON.parse(selectedVariant) : null;
      }

      renderProductInfo({ requestUrl, targetId, callback }) {
        this.abortController?.abort();
        this.abortController = new AbortController();
        
        fetch(requestUrl, { signal: this.abortController.signal })
          .then((response) => response.text())
          .then((responseText) => {
            this.pendingRequestUrl = null;
            const html = new DOMParser().parseFromString(responseText, 'text/html');
            callback(html);
          })
          .then(() => {
            // set focus to last clicked option value
            document.querySelector(`#${targetId}`)?.focus();
            document.dispatchEvent(
              new CustomEvent('productinfo:changed')
            );
            this.reattachModalButtons();
          })
          .catch((error) => {
            if (error.name === 'AbortError') {
              console.log('Fetch aborted by user');
            } else {
              console.error(error);
            }
          });
      }
      
      reattachModalButtons() {
        
        const modalButtons = this.querySelectorAll('variant-selects .product-modal-link');
        
        if (modalButtons) {
          modalButtons.forEach((button)=>{
            const id = button.getAttribute('aria-controls');
            const modal = document.getElementById(id);
            if (modal) {
              button.addEventListener('click', (event)=>{
                modal.onButtonClick(event);
              });
            }
          });
        }
      }

      updateOptionValues(html) {
        const variantSelects = html.querySelector('variant-selects');
        if (variantSelects) {
          HTMLUpdateUtility.viewTransition(this.variantSelectors, variantSelects, this.preProcessHtmlCallbacks);
        }
      }

      updateURL(url, variantId) {
        if (this.dataset.updateUrl === 'false') return;
        window.history.replaceState({}, '', `${url}${variantId ? `?variant=${variantId}` : ''}`);
      }

      updateVariantInputs(variantId) {
        document
          .querySelectorAll(`#product-form-${this.dataset.section}, #product-form-installment-${this.dataset.section}`)
          .forEach((productForm) => {
            const input = productForm.querySelector('input[name="id"]');
            input.value = variantId ?? '';
            input.dispatchEvent(new Event('change', { bubbles: true }));
          });
      }

      updateMedia(variant) {
        const productMedia = this.querySelector(`[id^="MediaGallery-${this.dataset.section}"]`);
        if (!productMedia) return; // Early return if productMedia is not found

        const setActiveMedia = () => {
          if (typeof productMedia.setActiveMedia === 'function') {
            productMedia.init();
            productMedia.setActiveMedia(variant);
            return true; // Indicate success
          }
          return false; // Indicate failure
        };

        if (!setActiveMedia()) {
          this.timer = setInterval(() => {
            if (setActiveMedia()) {
              clearInterval(this.timer);
            }
          }, 100);
        }
      }

      updateShareUrl(variantId) {
        if (!variantId) return;
        const shareButton = document.getElementById(`ProductShare-${this.dataset.section}`);
        if (!shareButton || !shareButton.updateUrl) return;
        shareButton.updateUrl(`${window.shopUrl}${this.dataset.url}?variant=${variantId}`);
      }

      toggleAddButton(disable = true, text, modifyClass = true) {
        const productForm = document.getElementById(`product-form-${this.dataset.section}`);
        if (!productForm) return;
        const addButton = productForm.querySelector('[name="add"]');
        const addButtonText = productForm.querySelector('[name="add"] > span');
        const shippingProperty = productForm.querySelector('[name="properties[:]"]');
        if (!addButton) return;

        if (disable) {
          addButton.setAttribute('disabled', 'disabled');
          if (text) addButtonText.textContent = text;
        } else {
          addButton.removeAttribute('disabled');
          if (shippingProperty && shippingProperty.value != 'Ships Now') {
            addButtonText.textContent = PCOtheme.variantStrings.preorder;
          } else {
            addButtonText.textContent = PCOtheme.variantStrings.addToCart;
          }
        }

        if (!modifyClass) return;
      }

      setUnavailable() {
        const button = document.getElementById(`product-form-${this.dataset.section}`);
        const addButton = button.querySelector('[name="add"]');
        const addButtonText = button.querySelector('[name="add"] > span');
        const price = document.getElementById(`price-${this.dataset.section}`);
        const inventory = document.getElementById(`Inventory-${this.dataset.section}`);
        const sku = document.getElementById(`Sku-${this.dataset.section}`);
        
        if (!addButton) return;
        addButton.setAttribute('disabled', 'disabled');
        addButtonText.textContent = PCOtheme.variantStrings.unavailable;
        if (price) price.classList.add('hidden');
        if (inventory) inventory.classList.add('hidden');
        if (sku) sku.classList.add('hidden');
      }

      initQuantityHandlers() {
        if (!this.quantityInput) return;

        this.setQuantityBoundries();
        if (!this.hasAttribute('data-original-section')) {
          this.cartUpdateUnsubscriber = PCOtheme.pubsub.subscribe(
            PCOtheme.pubsub.PUB_SUB_EVENTS.cartUpdate,
            this.fetchQuantityRules.bind(this)
          );
        }
      }

      setQuantityBoundries() {
        PCOtheme.pubsub.publish(PCOtheme.pubsub.PUB_SUB_EVENTS.quantityBoundries, {
          data: {
            sectionId: this.sectionId,
            productId: this.productId,
          },
        });
      }

      fetchQuantityRules() {
        const currentVariantId = this.productForm?.productIdInput?.value;
        if (!currentVariantId) return;

        this.querySelector('.quantity__rules-cart')?.classList.add('btn--loading');

        fetch(`${this.getAttribute('data-url')}?variant=${currentVariantId}&section_id=${this.sectionId}`)
          .then((response) => response.text())
          .then((responseText) => {
            const parsedHTML = new DOMParser().parseFromString(responseText, 'text/html');
            this.updateQuantityRules(this.sectionId, this.productId, parsedHTML);
          })
          .catch((error) => {
            console.error(error);
          })
          .finally(() => {
            this.querySelector('.quantity__rules-cart')?.classList.remove('btn--loading');
          });
      }

      updateQuantityRules(sectionId, productId, parsedHTML) {
        if (!this.quantityInput) return;

        PCOtheme.pubsub.publish(PCOtheme.pubsub.PUB_SUB_EVENTS.quantityRules, {
          data: {
            sectionId,
            productId,
            parsedHTML,
          },
        });

        this.setQuantityBoundries();
      }
    }
  );
}


// ! PRODUCT MEDIA GALLERY

if (!customElements.get('product-media-gallery')) {
  
  customElements.define(
    
    'product-media-gallery',
    
    class ProductMediaGallery extends HTMLElement {
      
      constructor() {
        super();
        
        this.overlay = this.querySelector('.product-media-slider');
        this.swiperWrapper = this.querySelector('.swiper-wrapper');
        
        if (!this.overlay || !this.swiperWrapper) return;
        
        this.zoomTriggers = this.querySelectorAll('.product-gallery__item');
        this.closeButton = this.querySelector('.product-product-gallery__close');
        this.openClass = 'is-open';
        this.lockScrollingClass = 'modal-show';
        
        this.initSwiper();
        
        if (this.zoomTriggers) {
          
          this.zoomTriggers = Array.from(this.zoomTriggers);
          
          this.zoomTriggers.forEach((trigger) => {
            
            // open gallery on click
            trigger.addEventListener('click', (event) => {
              this.openGallery( this.zoomTriggers.indexOf(trigger) );
            });
          });
          
          // close gallery when mobile
          document.addEventListener('matchMobile', () => {
            this.closeGallery();
          });
        }
        
        if (this.closeButton) {
          this.closeButton.addEventListener('click', (event) => {
            event.preventDefault();
            this.closeGallery();
          });
        }
        
      }
      
      openGallery(slideIndex) {
        
        // immediately go to clicked image (speed of 0ms)
        if (typeof this.sliderInstance === 'object') {
          this.sliderInstance.slideTo(slideIndex, 0);
        }
        
        // set all triggers to expanded
        this.zoomTriggers.forEach((trigger) => {
          trigger.setAttribute('aria-expanded', 'true');
        });
        
        // reveal the overlay
        document.body.classList.add( this.lockScrollingClass );
        this.overlay.classList.add( this.openClass );
        
        // keys that will trigger modal close
        const closeKeys = [
          'ESCAPE',
          'KEYX'
        ]
        
        // store reference to 'this' for use in window scope below
        const _self = this;
        
        // listen for key press
        function keyListener(event) {
          if (closeKeys.includes(event.code.toUpperCase())) {
            _self.closeGallery();
            window.removeEventListener('keydown', keyListener);
          }
        }
        window.addEventListener('keydown', keyListener);
      }
      
      closeGallery() {
        
        // set all triggers to collapsed
        this.zoomTriggers.forEach((trigger) => {
          trigger.setAttribute('aria-expanded', 'false');
        });
        
        // hide the overlay
        this.overlay.classList.remove( this.openClass );
        document.body.classList.remove( this.lockScrollingClass );
      }
      
      initSwiper() {
        
        const slider = this.querySelector('.swiper');
        
        if (!slider) return;
        
        this.sliderInstance = new PCOtheme.Swiper.Swiper(slider, {
          modules: [
            PCOtheme.Swiper.Pagination,
            PCOtheme.Swiper.Navigation
          ],
          pagination: PCOtheme.Swiper.PaginationDefault,
          navigation: PCOtheme.Swiper.NavigationDefault,
          speed: 500,
          spaceBetween: 0
        });
      }
      
    }
  );
}